var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2309_10952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.71498 2.12584C5.71498 1.37197 6.3283 0.758652 7.08217 0.758652H7.55533L7.41259 0.361895C7.33234 0.13877 7.12206 0 6.89795 0C6.83586 0 6.77269 0.0106641 6.71095 0.0331406L1.92981 1.77332C1.64558 1.87679 1.49929 2.19133 1.60336 2.47535L1.85599 3.1649H5.71498V2.12584Z",
    fill: "url(#paint0_linear_2309_10952)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08203 1.57886C6.77999 1.57886 6.53516 1.82369 6.53516 2.12573V3.1648H11.3203V2.12573C11.3203 1.82369 11.0755 1.57886 10.7734 1.57886H7.08203Z",
    fill: "url(#paint1_linear_2309_10952)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7695 11.0535H10.8555C9.72467 11.0535 8.80469 10.1335 8.80469 9.00269C8.80469 7.87189 9.72467 6.9519 10.8555 6.9519H12.7695V5.07886C12.7695 4.47481 12.2798 3.98511 11.6758 3.98511H1.09375C0.489699 3.98511 0 4.47481 0 5.07886V12.9061C0 13.5102 0.489699 13.9999 1.09375 13.9999H11.6758C12.2798 13.9999 12.7695 13.5102 12.7695 12.9061V11.0535Z",
    fill: "url(#paint2_linear_2309_10952)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5898 7.77222H10.8555C10.177 7.77222 9.625 8.32421 9.625 9.00269C9.625 9.68117 10.177 10.2332 10.8555 10.2332H13.5898C13.816 10.2332 14 10.0492 14 9.823V8.18237C14 7.95621 13.816 7.77222 13.5898 7.77222ZM10.8555 9.41284C10.629 9.41284 10.4453 9.2292 10.4453 9.00269C10.4453 8.77617 10.629 8.59253 10.8555 8.59253C11.082 8.59253 11.2656 8.77617 11.2656 9.00269C11.2656 9.2292 11.082 9.41284 10.8555 9.41284Z",
    fill: "url(#paint3_linear_2309_10952)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2309_10952",
    x1: 1.56982,
    y1: 1.58245,
    x2: 7.55533,
    y2: 1.58245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D39118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2309_10952",
    x1: 6.53516,
    y1: 2.37183,
    x2: 11.3203,
    y2: 2.37183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D39118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2309_10952",
    x1: -4.75702e-8,
    y1: 8.9925,
    x2: 12.7695,
    y2: 8.9925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D39118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2309_10952",
    x1: 9.625,
    y1: 9.00269,
    x2: 14,
    y2: 9.00269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D39118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB43"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2309_10952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletFill);
export default __webpack_public_path__ + "static/media/wallet-fill.25298104d23a652d05bb144114adf5a7.svg";
export { ForwardRef as ReactComponent };